import { map, take, timer } from "rxjs";
import { CdpaAlertComponent, CdpaAlertId } from "../../common/components/cdpaAlert.component";
import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { Slugs } from "../../common/components/slug.loader";
import { CdpaMultiFieldInput } from "./cdpaMultiFieldInput/cdpa-multi-field-input";
import { attachHandlers, attachValidationOnSubmitClick } from "./formHelpers/formHelpers";
import { FormId } from "./common/formId";
import "./email-code-form.scss";
import "./template.scss";
const RESEND_BUTTON_COUNTDOWN = 30; // seconds
export class EmailCodeForm {
    constructor() {
        this.submitButton = new CdpaButtonComponent(CdpaButtonId.EmailCodeLogin);
        this.resendButton = new CdpaButtonComponent(CdpaButtonId.EmailCodeResend);
        const form = document.getElementById(FormId.EmailCodeForm);
        const codeInput = new CdpaMultiFieldInput(EmailCodeForm.inputClass, "email-code-wrapper", "email-code__error-label");
        attachValidationOnSubmitClick(this.submitButton, form, [codeInput]);
        attachHandlers([[this.resendButton.onClick$, this.onResendClick.bind(this)]]);
        codeInput.onValidPaste$.subscribe(() => {
            this.submitButton.click();
        });
        // temporary blocked user alert
        const blockDuration = parseInt(form.dataset.blockDuration ?? "");
        if (blockDuration && document.getElementById(CdpaAlertId.GlobalAlert)) {
            const alert = new CdpaAlertComponent(CdpaAlertId.GlobalAlert);
            const blockFormHandler = (event) => {
                event.preventDefault();
                event.stopPropagation();
            };
            alert.addCountdown(blockDuration);
            this.submitButton.setDisabled(true);
            this.resendButton.setDisabled(true);
            form.addEventListener("submit", blockFormHandler);
            setTimeout(() => {
                this.submitButton.setDisabled(false);
                this.resendButton.setDisabled(false);
                form.removeEventListener("submit", blockFormHandler);
            }, blockDuration * 1000);
        }
        else {
            this.startResendCountdown();
        }
    }
    // The resend logic is similar to the login button logic (see above), this time passing an empty input with a name of 'resend' to ensure the backend resends the otp code
    onResendClick(e) {
        if (this.resendButton.isLoading) {
            e.preventDefault();
            return;
        }
        this.resendButton.isLoading = true;
    }
    startResendCountdown() {
        this.resendButton.setDisabled(true);
        const countdown = RESEND_BUTTON_COUNTDOWN;
        timer(0, 1000)
            .pipe(take(countdown + 1), map((i) => countdown - i))
            .subscribe({
            next: (value) => {
                const buttonLabel = `${Slugs.translated.resendIn}  ${value}  ${Slugs.translated.sec}`;
                this.resendButton.setLabel(buttonLabel);
            },
            complete: () => {
                if (!this.submitButton.isDisabled) {
                    this.resendButton.setDisabled(false);
                }
                this.resendButton.setLabel(Slugs.translated.resendCode);
            }
        });
    }
}
EmailCodeForm.inputClass = "email-code__input";
